import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from 'ui/Flex/Flex';
import DataLocked from 'assets/data_locked.svg?react';
import { SxProps, Theme, Typography } from '@mui/material';

function Forbidden({ sx }: { sx?: SxProps<Theme> }): React.ReactElement {
    const { t } = useTranslation();
    return (
        <Flex sx={sx} direction="column" align="center" justify="center">
            <DataLocked
                viewBox="0 0 165 110"
                width="600"
                height="400"
                role="img"
                aria-label="locked page"
            />
            <Typography variant="h4">{t('forbidden.title')}</Typography>
        </Flex>
    );
}

export default Forbidden;
